import { TENANT_OS_ENDPOINT_BASE_URL } from '@kfc-global/react-shared/config/config.constants';
import { config } from '@kfc-global/react-shared/config/config.utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { hideLoader, showLoader } from '@kfc-global/react-shared/redux/Actions/LoaderAction';
import { getBulkStoreStatus, setGeoHashCount } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import geoLocation from '@kfc-global/react-shared/utils/geoLocation.js';
import { ChannelManager } from 'common/manager';
import {
  getDispositionTypeOnAPIFormat,
  getTernaryValue,
  isValidValue,
  getValueOrDefaultObject,
  getValueOrEmptyString,
} from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
import SEARCH_STORE_CONSTANTS from '../Constants/SearchStoreConstants';
import SEARCHSTORE_MODULE_DATA from '../Data/Defaults';
import DeliveryModuleForm from '../Presentation/DeliveryModuleForm';
import SearchStoreInsideModal from '../Presentation/SearchStoreInsideModal';
import SearchStoreModuleForm from '../Presentation/SearchStoreModuleForm';
import { calculateStoreDistance, getDistanceFromGoogleMatrix } from '../SearchStoreUtilities/geoUtils';
import { getStoreStatusData, setLocalisedSignInAnalyticsData } from '../SearchStoreUtilities/SearchStoreUtils';
import { login } from 'common/utilities/LoginUtils';

export const SearchStoreModule = props => {
  const { contentData = {}, onStoreSelectFinish } = props;

  const { SEARCH_ORDER_DATA, DISPOSITION_DATA, ANALYTICS_LOCALISATION_SIGNIN } = START_ORDER_CONSTANTS;

  const dispatch = useDispatch();

  const { COUNTRY_CODE, STORE_CARD_LIMIT, TYPE_TAKE_WAY, PICK_UP, TENANT_ID, TENATNT_SESSION_ID, TYPE_DELIVERY } =
    SEARCH_STORE_CONSTANTS;

  // get the context from parent
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { dispositionStateData, searchStoreData } = userOrderState;
  const { dispositionType = localStorage.getItem('dispositionType') } = getValueOrEmptyString(dispositionStateData);
  const {
    currentMarket = COUNTRY_CODE,
    storeCardLimit = STORE_CARD_LIMIT,
    storeStatusUrl = `${config(TENANT_OS_ENDPOINT_BASE_URL)}v1/stores/{storeid}/{channel}/{service}/status`,
    tenantID = TENANT_ID,
    tenantSessionID = TENATNT_SESSION_ID,
  } = searchStoreData;

  const { searchStoreHeaderText = '', deliveryHeaderText = '', searchStoreModalContent = {} } = contentData;

  const {
    formContent = {},
    locationsContent: { storeData = [] },
  } = searchStoreModalContent;
  // state variable to store all eligible store informations
  const [eligibleStoreData, seteligibleStoreData] = React.useState([]);
  const [userLocation, setUserLocation] = React.useState({});
  const [favoriteStoreData, setFavoriteStoreData] = React.useState([]);
  const [nearByStores, setNearByStores] = React.useState([]);

  const { storeSearch = {}, tenantId } = useSelector(data => getValueOrDefaultObject(data.tenantReducer));
  const {
    allStores = [],
    storesWithStatus = [],
    isStoreStatusLoading = false,
  } = useSelector(data => getValueOrDefaultObject(data.storesReducer));
  const {
    maxDriveTimeMins,
    distanceMetrics,
    maxDeliveryDistanceMtrs,
    maxPickupDistanceMtrs,
    geohashprecision,
    boundingBoxSizeMeters,
  } = storeSearch;
  /**
   * Method to handle close button click on modal behavior
   */
  const handleClose = event => {
    event.stopPropagation();
    event.preventDefault();
    localStorage.setItem('renderComp', true);
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: false } });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
  };

  useEffect(() => {
    const closeSearchStoreModal = eventOfSeachStoreModal => {
      if (eventOfSeachStoreModal.keyCode === 27) {
        handleClose(eventOfSeachStoreModal);
      }
    };
    window.addEventListener('keydown', closeSearchStoreModal);
    return () => window.removeEventListener('keydown', closeSearchStoreModal);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Method to handle go back button click on modal behavior
   */
  const handleGoBack = event => {
    event.stopPropagation();
    event.preventDefault();
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
  };
  /**
   *
   * @param {*} event - event on link clicking
   */
  const singInClickhandler = event => {
    event.stopPropagation();
    event.preventDefault();
    localStorage.setItem(ANALYTICS_LOCALISATION_SIGNIN, JSON.stringify(true));
    setLocalisedSignInAnalyticsData();
    setTimeout(() => {
      login();
    }, 500);
  };

  const favouriteStores = useSelector(({ profileReducer: { favouriteStores } }) => favouriteStores);

  useEffect(() => {
    getUserFavLatLong({ userLat: userLocation.userLat, userLong: userLocation.userLong });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favouriteStores.length]);

  useEffect(() => {
    allStores.length > 0 && validateNearBystoreResponse(allStores);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allStores]);

  useEffect(() => {
    storesWithStatus.length > 0 && filterStatusCallResponse(storesWithStatus);
  }, [storesWithStatus]);

  useEffect(() => {
    dispositionType?.toUpperCase() === TYPE_DELIVERY && googleDistanceAPI(nearByStores);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nearByStores]);

  const getUserFavLatLong = userPosition => {
    calculateStoreDistance(userPosition.userLat, userPosition.userLong, favouriteStores, getAllSortedFavStoresData);
  };

  const getAllSortedFavStoresData = (allSortedFavStoreData, userAddress) => {
    const serviceType = getTernaryValue(dispositionType?.toUpperCase() === TYPE_TAKE_WAY, PICK_UP, dispositionType);
    const url = storeStatusUrl
      .replace('{channel}', ChannelManager.channel)
      .replace('{service}', serviceType)
      .replace(' ', '-');
    const tenantRequestId = uuidv4();
    getStoreStatusData(
      allSortedFavStoreData,
      url.toLowerCase(),
      tenantID,
      tenantSessionID || uuidv4(),
      tenantRequestId,
      updateFavStoreData,
    );
  };

  const updateFavStoreData = favStoreInfo => {
    let userFavStore = favStoreInfo;
    let selectedStoreInfo = userFavStore.map(item => {
      const { additionalProperties = [], address, amenities, dname, id, location } = item.storeBasic;
      return {
        ...item,
        id: id,
        location: location,
        name: dname,
        amenities: amenities,
        addresses: address,
        additionalAttributes: additionalProperties,
        storeBasic: {},
      };
    });
    setFavoriteStoreData(selectedStoreInfo);
  };

  /**
   * method to get user's lat long values
   */
  const getUserLatLong = userPosition => {
    //pass delivery time limit after converting to seconds
    dispatch(showLoader());
    setUserLocation({ userLat: userPosition.userLat, userLong: userPosition.userLong });
    eligibleStoreData && seteligibleStoreData([]);
    getNearbyStores(userPosition.userLat, userPosition.userLong);

    setTimeout(() => {
      dispatch(hideLoader());
    }, 2000);
  };

  //Method to get nearBystores
  const getNearbyStores = (lat, lon) => {
    const calculateGHPayload = {
      lat: lat,
      lon: lon,
      distanceFromCurrentLoc: boundingBoxSizeMeters / 1000,
      geohashprecision: geohashprecision,
    };
    const geoHash = geoLocation.calculateGH(calculateGHPayload);
    dispatch(setGeoHashCount(geoHash?.length));
  };

  //Method to validate nearBystores
  const validateNearBystoreResponse = allStoresData => {
    const serviceType = getDispositionTypeOnAPIFormat(dispositionType.toUpperCase());
    const validatedNearBystoresData = allStoresData.filter(store => {
      return (
        isValidValue(store.id) && isValidValue(store?.location?.latitude) && isValidValue(store?.location?.longitude)
      );
    });

    //calculate linear Distance
    const linearDistancePayload = {
      stores: validatedNearBystoresData,
      disposition: serviceType,
      distanceMetrics: distanceMetrics,
      driveTime: maxDriveTimeMins,
      distanceInMtrs: getTernaryValue(
        dispositionType.toUpperCase() === TYPE_DELIVERY,
        maxDeliveryDistanceMtrs,
        maxPickupDistanceMtrs,
      ),
      noOfStores: getTernaryValue(dispositionType.toUpperCase() === TYPE_DELIVERY, 2, validatedNearBystoresData.length),
      channel: ChannelManager.channel,
    };
    const linearDistance = geoLocation.checkAndProceed(linearDistancePayload);

    //In order to merge
    setNearByStores(linearDistance);

    //conditionally call  google API
    dispositionType.toUpperCase() === TYPE_DELIVERY
      ? googleDistanceAPI(linearDistance)
      : callStatusAPI(linearDistance, serviceType);
  };

  const googleDistanceAPI = origin => {
    let originCoordinates = [];
    origin?.forEach(element => {
      originCoordinates.push({ lat: element.location?.latitude, lng: element.location?.longitude });
    });
    getDistanceFromGoogleMatrix(
      originCoordinates,
      [{ lat: userLocation.userLat, lng: userLocation.userLong }],
      getGoogleApiResponse,
    );
  };

  const getGoogleApiResponse = ({ allStoreDistance, originAddressText }) => {
    const serviceType = getDispositionTypeOnAPIFormat(dispositionType.toUpperCase());

    //merge getGoogleApiResponse with nearBystores
    const googleApiMergedStores = mergeStoreData(allStoreDistance, nearByStores);

    //sort the merged stores
    const getSortedNearbyStoresPayload = {
      stores: googleApiMergedStores,
      numberOfStores: 2,
      disposition: serviceType,
      distanceMetrics: distanceMetrics,
      driveTime: maxDriveTimeMins,
      channel: ChannelManager.channel,
    };
    const sortedNearBystores = geoLocation.getSortedNearbyStores(getSortedNearbyStoresPayload);

    sortedNearBystores?.length > 0 && callStatusAPI(sortedNearBystores, serviceType);
  };

  const mergeStoreData = (storeDataOne, storeDataTwo) => {
    return(
      storeDataTwo?.map((storeTwo, index) => {
      return { ...storeTwo, distance: storeDataOne[index] };
    })
    )
  };

  const callStatusAPI = (storeList, serviceType) => {
    const dataList = storeList?.map(store => {
      return { storeId: store.id, channel: ChannelManager.channel, service: serviceType };
    });
    const statusCallPayload = {
      data: dataList,
      store: storeList,
      tenantId: tenantId,
      setStatusFlag: false,
      isFavoritePage: false,
    };
    dispatch(getBulkStoreStatus(statusCallPayload, null));
  };

  //validate stores getting from status call and get final stores
  const filterStatusCallResponse = storeList => {
    const finalStores = storeList.filter(store => {
      return (
        store?.id &&
        store?.location?.latitude &&
        store?.location?.longitude &&
        store?.summary?.status?.currentStatus &&
        store?.summary?.menu?.catalogs?.length &&
        store?.summary?.timings?.operatingHours?.length > 0 &&
        store?.summary?.timings?.asap
      );
    });
    seteligibleStoreData(finalStores);
  };

  const orderModeTypeItem =
    dispositionType?.toUpperCase() === TYPE_DELIVERY ? (
      <DeliveryModuleForm
        singInClickhandler={singInClickhandler}
        formContent={formContent}
        storeData={storeData}
        onStoreSelectFinish={onStoreSelectFinish}
        eligibleStoreData={eligibleStoreData}
        // eligibleStoreData={eligibleMockData}
        storeCardLimit={storeCardLimit}
        userPositionHandler={getUserLatLong}
        currentMarket={currentMarket}
      />
    ) : (
      <SearchStoreModuleForm
        singInClickhandler={singInClickhandler}
        formContent={formContent}
        storeData={storeData}
        eligibleStoreData={eligibleStoreData}
        noStoresList={isStoreStatusLoading}
        //eligibleStoreData={eligibleMockData}
        storeCardLimit={storeCardLimit}
        userPositionHandler={getUserLatLong}
        currentMarket={currentMarket}
        onStoreSelectFinish={onStoreSelectFinish}
        handleGoBack={handleGoBack}
        favoriteStoreData={favoriteStoreData}
        favoriteStoreHandler={getUserFavLatLong}
      />
    );

  // project the store results in modal
  return (
    <SearchStoreInsideModal
      handleClose={handleClose}
      orderModeTypeItem={orderModeTypeItem}
      headerText={getTernaryValue(
        dispositionType?.toUpperCase() === TYPE_DELIVERY,
        translateWithI18Next(deliveryHeaderText),
        translateWithI18Next(searchStoreHeaderText),
      )}
      handleGoBack={handleGoBack}
      modalTitleId='search-store'
    />
  );
};

// Defaults from defaults json file
SearchStoreModule.defaultProps = SEARCHSTORE_MODULE_DATA;

export default SearchStoreModule;
